// @refresh reload
import { mount, StartClient } from "@solidjs/start/client";
import { getFonts } from "./utils/etc";
import { initSentry, setClientIdTagInSentry } from "~/utils/third_party/sentry";
import { getCookie } from "./utils/client_cookie";
import {
  clientIdConfig,
  getMomentsV3PartnerConfig,
} from "./data/partner_config";

initSentry();

// Polyfills
if (!Object.hasOwnProperty("hasOwn")) {
  Object.defineProperty(Object, "hasOwn", {
    value: function (obj: any, prop: any) {
      if (obj == null) return false; // null and undefined are special cases
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
  });
}

if (
  !Array.prototype.hasOwnProperty("findLastIndex") ||
  typeof Array.prototype.findLastIndex !== "function"
) {
  Object.defineProperty(Array.prototype, "findLastIndex", {
    value: function <T>(
      predicate: (arg0: T, arg1: number, arg2: T[]) => boolean
    ) {
      for (let i = this.length - 1; i >= 0; i--) {
        if (predicate(this[i], i, this)) {
          return i;
        }
      }
      return -1;
    },
    writable: true,
    configurable: true,
  });
}

if (typeof String.prototype.replaceAll !== "function") {
  String.prototype.replaceAll = function (
    pattern: string | RegExp,
    replacement: string | ((substring: string, ...args: any[]) => string)
  ) {
    if (typeof pattern === "string") {
      pattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    const regex = new RegExp(pattern, "g");

    if (typeof replacement === "function") {
      return this.replace(regex, replacement);
    }

    return this.replace(regex, replacement);
  };
}

if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    index = Math.trunc(index) || 0;

    if (index < 0) {
      index += this.length;
    }

    if (index < 0 || index >= this.length) {
      return undefined;
    }

    return this[index];
  };
}

function applyRnrSpecificStyles(clientId: string) {
  const partnerConfig = getMomentsV3PartnerConfig(clientId);
  const isDarkTheme = partnerConfig.theme === "telescope-dark-theme";

  if (window.location.hostname.includes("raisoni")) {
    const cssLink = document.createElement("link");
    cssLink.rel = "stylesheet";
    cssLink.href = "/styles/raisoni.css";
    document.head.appendChild(cssLink);

    // add classes imported from css file
    document.body.classList.add("raisoni-font-family");
    document.body.classList.add("raisoni-font-weights");
    document.body.classList.add("raisoni-colors");
  }

  if (clientId == clientIdConfig.axisClientId) {
    const cssLink = document.createElement("link");
    cssLink.rel = "stylesheet";
    cssLink.href = "/styles/axis.css";
    document.head.appendChild(cssLink);
  }

  if (clientId == clientIdConfig.mastercardIndriyaClientId) {
    const cssLink = document.createElement("link");
    cssLink.rel = "stylesheet";
    cssLink.href = "/styles/mastercard-indriya.css";
    document.head.appendChild(cssLink);
  }

  if (clientId == clientIdConfig.iciciIndriyaClientId) {
    const cssLink = document.createElement("link");
    cssLink.rel = "stylesheet";
    cssLink.href = "/styles/icici-indriya.css";
    document.head.appendChild(cssLink);
  }

  if (clientId && isDarkTheme === true) {
    document.body.classList.add("darkTheme");
  }
}

function applyGiftingSpecificStyles() {
  const pathname = window.location.pathname;

  if (
    pathname.includes("pluto") ||
    pathname.includes("smart-gc") ||
    pathname.includes("gift-box")
  ) {
    // manually make body bg black for dark theme products
    document.body.classList.add("darkBg");
  }
}

function loadCSSBasedOnURLParam() {
  // apply default css
  const cssFile = "/styles/main.css";
  const cssLink = document.createElement("link");
  cssLink.rel = "stylesheet";
  cssLink.href = cssFile;
  document.head.appendChild(cssLink);

  // apply default fonts
  const fonts = getFonts();
  fonts.map((font) => {
    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = font;
    return document.head.appendChild(fontLink);
  });

  // rnr
  const clientIdFromCookie = getCookie("clientId");
  if (clientIdFromCookie) {
    setClientIdTagInSentry(clientIdFromCookie);
    applyRnrSpecificStyles(clientIdFromCookie);
  }

  let hostname = window.location.hostname;

  if (hostname.includes("tata-digital") || hostname.includes("tatadigital")) {
    document.body.classList.add("darkTheme");
  }

  // gifting
  applyGiftingSpecificStyles();
}

loadCSSBasedOnURLParam();

mount(() => <StartClient />, document.getElementById("app")!);
